import { render, staticRenderFns } from "./Dispatch.vue?vue&type=template&id=7b56e5f9&"
import script from "./Dispatch.vue?vue&type=script&lang=ts&"
export * from "./Dispatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports